export { default as YourAwesomeComponent } from "./components/your-awesome-component";
export { default as RenderFriend } from "./components/render-friend";
export { default as GuestList } from "./components/guest-list";



// WEBPACK FOOTER //
// ./src/index.js